import { faEraser, faFileInvoiceDollar, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Col, Row, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { listParamsAction } from '../../actions/paramsActions';

import SpinnerBlock from '../../components/Common/Spinner/Spinner';
import Layout from '../Layout';
import Results from './Results';

import alertMessages from '../../helpers/alertMessages';
import apiMethods from '../../constants/apiMethods';
import routes from '../../constants/routes';
import api from '../../helpers/api';
import es from '../../lang/es';

const PreForm = () => {
    //Navigator
    let navigate = useNavigate();

    const refProceeding = useRef();
    const refJurisdiction = useRef();
    //Inicializo el state local
    const [ loading, setLoading ] = useState(false);
    const [ disabled, setDisabled ] = useState(false);
    const [ proceedings, setProceedings ] = useState(null);
    const [ filter, setFilter ] = useState({
        jurisdiction: '',
        proceeding: ''
    });
    //Dispatch
    const dispatch = useDispatch();
    //Store
    const params = useSelector( state => state.params.params );
    const jurisdictions = useSelector( state => state.params.jurisdictions );
    //Actions
    const actions = [
        {
            title: es.ACTIONS.CHECKOUT,
            type: 'primary',
            icon: faFileInvoiceDollar,
            visible: true,
            handle: () => {
                navigate(routes.PAYMENT_CHECKOUT)
            }
        },
        {
            title: es.CLOSE.toUpperCase(),
            type: 'danger',
            icon: faTimes,
            visible: true,
            handle: () => {
                navigate(routes.HOME)
            }
        }
    ];
    //Manejo la carga de parámetros
    const loadParams = () => {
        if(!params){
            //Dispatch
            dispatch( listParamsAction() );
        }
    }
    //Inicio
    useEffect(() => {
        loadParams();
    }, []);
    //Manejo los cambios
    const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        })

        if(e.target.name == 'jurisdiction'){
            refProceeding.current.focus();
        }
    }
    //Manejo el reseteo
    const handleReset = e => {
        e.preventDefault();
        //Limpio los valores
        setFilter({
            proceeding: '',
            jurisdiction: ''
        })
        //Limpio los resultados
        setProceedings(null);
        //Habilito los campos
        setDisabled(false);

        setTimeout(() => {
            refJurisdiction.current.focus();
        }, 500);
    }
    //Función que maneja la búsqueda
    const handleSearch = async e => {
        e.preventDefault();
        //Bloqueo los campos
        setLoading(true);
        setDisabled(true);
        //Realizao la búsqueda
        try{
            const params = {
                f: filter.jurisdiction,
                e: filter.proceeding
            }
            const response = await api.get(apiMethods.PROCEEDINGS, { params });
            //Obtengo los datos
            const res = response.data;
            //Seteo los valores
            setProceedings(res.data);
            //Oculto la espera
            setLoading(false)
        }catch(error){
            const errorResponse = error.response;
            let errorData = {
                data: null,
                message: es.ERRORS.SERVER_CONN
            };
            //Verifico si hay error
            if(errorResponse){
                errorData = errorResponse.data;
            }
            //Oculto la espera
            setLoading(false);
            //Muestro mensaje de error
            alertMessages.error(errorData.message);
            //Debo permitir realizar otr búsqueda
            setDisabled(false);
        }
    }
    //Render
    return (
        <SpinnerBlock active={loading}>
            <Layout
                title={es.APP_NAME}
                subtitle={es.PAYMENTS.CREATE}
                items={[
                    {
                        title: es.HOME,
                        link: routes.HOME
                    },
                    {
                        title: es.ACTIONS.NEW,
                        active: true
                    }
                ]}
                actions={actions}
            >
                <Col xs={12}>
                    <Alert variant="info">
                    Seleccione el <strong>FUERO</strong> al que pertenece el expediente, y luego ingrese el <strong>NRO. DE EXPEDIENTE</strong> completo. Al finalizar haga click en <strong>BUSCAR</strong> para obtener los datos del mismo.
                    </Alert>
                </Col>
                <Form className="col" onSubmit={handleSearch}>
                    <Row>
                        <Col xs={12} md={5} sm={6}>
                            <Form.Group>
                                <Form.Control
                                    as="select"
                                    name="jurisdiction"
                                    required
                                    autoFocus
                                    onChange={handleChange}
                                    value={ filter.jurisdiction }
                                    disabled={disabled}
                                    ref={refJurisdiction}
                                >
                                    <option value="">{ es.SELECT.JURISDICTION }</option>
                                    {
                                        jurisdictions ? (
                                            jurisdictions.map( jurisdiction => (
                                                <option value={jurisdiction.id} key={`jo${jurisdiction.id}`}>
                                                    { jurisdiction.description }
                                                </option>
                                            ))
                                        ) : null
                                    }
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col lg={2} sm={5}>
                            <Form.Group>
                                <Form.Control
                                    type="text"
                                    name="proceeding"
                                    required
                                    onChange={handleChange}
                                    value={ filter.proceeding }
                                    disabled={disabled}
                                    ref={refProceeding}
                                />
                            </Form.Group>
                        </Col>
                        <Col lg={1}>
                            <Form.Group>
                                <Button block type="submit" variant="primary" disabled={disabled}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </Button>
                            </Form.Group>
                        </Col>
                        <Col lg={1}>
                            <Form.Group>
                                <Button block type="reset" variant="warning" onClick={handleReset} disabled={loading}>
                                    <FontAwesomeIcon icon={faEraser} />
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
                
                {
                    proceedings ? (
                        <Results
                            proceedings={proceedings}
                            jurisdiction={filter.jurisdiction}
                        />
                    ) : null
                }
            </Layout>
        </SpinnerBlock>
    );
};

export default PreForm;